import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
// import ReactGA from 'react-ga4';
import TagManager from '@sooro-io/react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-NLB6VK7J',
};
TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

//Initialize GA4
// ReactGA.initialize('G-Z841MKN2CW');

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// const SendAnalytics = () => {
//   ReactGA.send({
//     hitType: 'pageview',
//     page: window.location.pathname,
//   });
// };

// reportWebVitals(SendAnalytics);
